import { BaseWebComponentDataProvider } from './BaseWebComponentDataProvider';

export class BaseWebComponentDataProviderFactory {
  protected map = new Map<string, any>();

  build<T extends BaseWebComponentDataProvider>(type: string): T {
    if (!type) {
      throw new Error(`Type for web components data provider factory was not supplied`);
    }
    if (this.map.has(type)) {
      const cls = this.map.get(type);
      if (!cls) {
        throw new Error(`Type ${type} cannot be built by web components data provider factory`);
      }
      return new cls();
    }
    throw new Error(`Type ${type} cannot be built by web components data provider factory`);
  }
}
